var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { LeakageCauseOutsideHouseDetail } from '@shared/types/api/claim';
const settings = namespace('settings');
let OutsideHouse = class OutsideHouse extends Vue {
    constructor() {
        super(...arguments);
        this.DetailType = LeakageCauseOutsideHouseDetail;
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    get customConfig() {
        var _a, _b, _c, _d, _e, _f, _g;
        return (((_g = (_f = (_e = (_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.roomDamagesContents) === null || _d === void 0 ? void 0 : _d.housingConfigurationByHousingType) === null || _e === void 0 ? void 0 : _e.house) === null || _f === void 0 ? void 0 : _f.selectedRoomsMapping) === null || _g === void 0 ? void 0 : _g.outsideHouse) || null);
    }
    leakageLocation(outsideCause) {
        var _a;
        return ((_a = this.customConfig) === null || _a === void 0 ? void 0 : _a[outsideCause]) || outsideCause;
    }
};
__decorate([
    settings.Getter('setting')
], OutsideHouse.prototype, "setting", void 0);
OutsideHouse = __decorate([
    Component({
        props: {
            selectedDetail: {
                type: String,
                default: null,
            },
            hoveredDetail: {
                type: String,
                default: null,
            },
        },
    })
], OutsideHouse);
export default OutsideHouse;
